"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSuitePartnerSubscriptionService = void 0;
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var AuthSuitePartnerSubscriptionService = /** @class */ (function () {
    function AuthSuitePartnerSubscriptionService(fetch) {
        this.fetch = fetch || auth_suite_fetch_1.authSuiteFetchWithAuthorization;
    }
    AuthSuitePartnerSubscriptionService.prototype.register = function (subscriptionId) {
        var path = "partnerSubscriptions/".concat(subscriptionId, "/register");
        return this.fetch.post({
            path: path,
        });
    };
    AuthSuitePartnerSubscriptionService.prototype.exchange = function (partnerCode, url) {
        var path = "partnerSubscriptions/".concat(partnerCode, "/exchange");
        var body = JSON.stringify({ url: url });
        return this.fetch.post({
            path: path,
            body: body,
        });
    };
    AuthSuitePartnerSubscriptionService.prototype.details = function (subscriptionId) {
        var path = "partnerSubscriptions/".concat(subscriptionId);
        return this.fetch.get({
            path: path,
        });
    };
    return AuthSuitePartnerSubscriptionService;
}());
exports.AuthSuitePartnerSubscriptionService = AuthSuitePartnerSubscriptionService;
